var n = Object.defineProperty;
var p = (s, i, r) => i in s ? n(s, i, { enumerable: !0, configurable: !0, writable: !0, value: r }) : s[i] = r;
var t = (s, i, r) => (p(s, typeof i != "symbol" ? i + "" : i, r), r);
import { PlausibleAPI as P } from "./analytics/api.js";
import { AppAPI as I } from "./app/api.js";
import { HistoryAPI as a } from "./history/api.js";
import { LockAPI as A } from "./locks/api.js";
import { PageAPI as h } from "./page/api.js";
import { SpaceAPI as c } from "./space/api.js";
import { SpacePermissionAPI as l } from "./spacepermission/api.js";
import { SubscriptionAPI as w } from "./subscription/api.js";
import { TemplateAPI as u } from "./template/api.js";
import { UserAPI as m } from "./user/api.js";
import { CollectionAPI as f } from "./collection/api.js";
import { ProductsAPI as d } from "./product/api.js";
import { StripeAPI as y } from "./app/stripe/api.js";
import { DocumentAPI as z } from "./document/api.js";
const e = class {
  constructor(i) {
    t(this, "api");
    t(this, "analyticsAPI");
    t(this, "appAPI");
    t(this, "documentAPI");
    t(this, "historyAPI");
    t(this, "lockAPI");
    t(this, "pageAPI");
    t(this, "spaceAPI");
    t(this, "spacePermissionAPI");
    t(this, "subscriptionAPI");
    t(this, "templateAPI");
    t(this, "userAPI");
    t(this, "collectionAPI");
    t(this, "productsAPI");
    t(this, "stripeAPI");
    this.api = i, this.analyticsAPI = new P(i), this.appAPI = new I(i), this.documentAPI = new z(i), this.historyAPI = new a(i), this.lockAPI = new A(i), this.pageAPI = new h(i), this.spaceAPI = new c(i), this.spacePermissionAPI = new l(i), this.subscriptionAPI = new w(i), this.templateAPI = new u(i), this.userAPI = new m(i), this.collectionAPI = new f(i), this.productsAPI = new d(i), this.stripeAPI = new y(i);
  }
  static getOrCreateInstance(i) {
    if (!i) {
      if (!e.defaultInstance)
        throw new Error("API is not initialized, call API.init(apiBaseURL);");
      return e.defaultInstance;
    }
    let r = e.instances.get(i);
    return r || (r = new e(i), e.instances.set(i, r), r);
  }
  static init(i) {
    if (e.defaultInstance)
      throw new Error("API is already initialized, this is likely due to running .init() twice in your program");
    e.defaultInstance = new e(i), e.instances.set(i, this.defaultInstance);
  }
  analytics() {
    if (!this.analyticsAPI || !this.analyticsAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.analyticsAPI;
  }
  app() {
    if (!this.appAPI || !this.appAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.appAPI;
  }
  document() {
    if (!this.documentAPI || !this.documentAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.documentAPI;
  }
  history() {
    if (!this.historyAPI || !this.historyAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.historyAPI;
  }
  lock() {
    if (!this.lockAPI || !this.lockAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.lockAPI;
  }
  page() {
    if (!this.pageAPI || !this.pageAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.pageAPI;
  }
  space() {
    if (!this.spaceAPI || !this.spaceAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.spaceAPI;
  }
  spacePermission() {
    if (!this.spacePermissionAPI || !this.spacePermissionAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.spacePermissionAPI;
  }
  subscription() {
    if (!this.subscriptionAPI || !this.subscriptionAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.subscriptionAPI;
  }
  template() {
    if (!this.templateAPI || !this.templateAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.templateAPI;
  }
  user() {
    if (!this.userAPI || !this.userAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.userAPI;
  }
  collection() {
    if (!this.collectionAPI || !this.collectionAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.collectionAPI;
  }
  products() {
    if (!this.productsAPI || !this.productsAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.productsAPI;
  }
  stripe() {
    if (!this.stripeAPI || !this.stripeAPI.api)
      throw new Error("API is not initialized with proper apiBaseURL");
    return this.stripeAPI;
  }
};
let o = e;
t(o, "defaultInstance"), t(o, "instances", /* @__PURE__ */ new Map());
export {
  o as API
};
